<template>
    <b-container fluid class="overview">
        <h1 class="text-left">{{ $t('apiSettings.title') }}</h1>
        <br />
        <div class="row">
            <!-- Search field -->
            <search-box
                id="searchApis"
                @input="$_onInput"
                :info="$t('searchInfo')"
                :autofocus="true"
                :value="searchText"
                :saveInState="true"
            >
            </search-box>
            <b-link class="px-1 pt-2" @click="$_clearFilters()">
                {{ $t('clearFilter') }}
            </b-link>
        </div>
        <!-- Overview Table -->
        <div>
            <b-table
                striped
                hover
                small
                outlined
                bordered
                v-show="dataLoaded"
                @row-clicked="$_onDetails"
                :tbody-tr-class="$_rowClass"
                :items="filteredRecords"
                :fields="fields"
                :sort-by.sync="sortBy"
                sort-icon-left
            >
            </b-table>
        </div>
        <!-- No content for overview -->
        <div v-show="noData" class="col-md-12">
            <span>{{ $t('organizationNonePresent') }}</span>
        </div>
        <router-links-footer :routerLinks="[{ name: 'apiSettingsNew' }]" />
    </b-container>
</template>

<script>
    import { orderBy } from 'lodash';
    import { EXTERNAL_API_TYPE } from '../../constants';
    import { nprogress } from '../../services/utilities';
    import SearchBox from '../../components/SearchBox.vue';
    import RouterLinksFooter from '../../components/dashboard/RouterLinksFooter.vue';

    export default {
        name: 'ApiSettingsOverview',
        components: {
            'search-box': SearchBox,
            'router-links-footer': RouterLinksFooter
        },

        data: function () {
            return {
                fields: [
                    {
                        key: 'name',
                        label: this.$t('apiSettings.nameTitle'),
                        sortable: true,
                        class: 'text-left',
                        thStyle: { border: 0 }
                    },
                    {
                        key: 'baseUrl',
                        label: this.$t('apiSettings.baseUrlTitle'),
                        sortable: true,
                        class: 'text-left',
                        thStyle: { border: 0 }
                    }
                ],
                sortBy: 'name',
                apiSettings: [],
                searchText: '',
                isResolved: false
            };
        },

        computed: {
            dataLoaded() {
                return this.apiSettings.length > 0;
            },

            noData() {
                return (
                    this.isResolved &&
                    this.apiSettings &&
                    this.apiSettings.length === 0
                );
            },

            filteredRecords() {
                let records = this.apiSettings.map((record) =>
                    // Stuff api settings do not need an preset url, so we show a not applicable message
                    ({ ...record, baseUrl: this.$_baseUrl(record) })
                );
                // filter records on NAME
                if (this.searchText && this.searchText.length > 0) {
                    const tokens = this.searchText.toLowerCase();
                    records = records.filter((record) => {
                        return record.name.toLowerCase().includes(tokens);
                    });
                }
                return orderBy(records, [(o) => o.name.toLowerCase()]);
            }
        },

        async created() {
            nprogress.start();
            const apiSettingsResult = await this.$store.dispatch('useApiData', {
                name: 'GetApis'
            });

            this.apiSettings = apiSettingsResult.data;
            this.isResolved = true;
            nprogress.done();
        },

        methods: {
            $_baseUrl(record) {
                if (record.apiType === EXTERNAL_API_TYPE.STUFF) {
                    return this.$t('notApplicable');
                }
                // otherwise
                return record.baseUrl;
            },

            $_onDetails(record) {
                this.$router.push({
                    path: `/dashboard/apiSettings/detail/${record.id}`
                });
            },

            $_onInput(searchText) {
                this.searchText = searchText;
            },

            $_rowClass() {
                return 'tablerow';
            },

            $_clearFilters() {
                this.$_onInput('');
            }
        }
    };
</script>

<style scoped>
.img-fluid {
    max-width: 100px !important;
    max-height: 35px !important;
}
</style>
